module.exports = __webpack_public_path__ + "static/media/gp.b7472423.svg";